document.addEventListener('DOMContentLoaded', function() {
  // Product ID for the promotion with bonus products
  const PRODUCT_ID = "8958357471499";
  
  // Validate product ID format
  if (!PRODUCT_ID || !/^\d+$/.test(PRODUCT_ID)) {
    console.error('Invalid product ID format. Cart promotion will not work correctly.');
    return; // Exit early if product ID is invalid
  }
  
  // Add the bonus product variant IDs directly
  const BONUS_VARIANT_ID = "51282651349259"; // The bonus variant ID for 6+ products
  const BONUS_VARIANT_ID_2 = "51394958393611"; // The bonus variant ID for 4+ products
  
  let isProcessing = false;

  async function reloadCartDrawer() {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // Fetch cart sections
      const response = await fetchWithRetry(`${routes.cart_url}?section_id=cart-drawer`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart items
      const sourceQty = doc.querySelector('cart-drawer-items');
      const targetQty = document.querySelector('cart-drawer-items');
      if (targetQty && sourceQty) {
        targetQty.innerHTML = sourceQty.innerHTML;
      }

      // Update cart footer
      const sourceFooter = doc.querySelector('.drawer__footer');
      const targetFooter = document.querySelector('.drawer__footer');
      if (targetFooter && sourceFooter) {
        targetFooter.innerHTML = sourceFooter.innerHTML;
      }

      // Handle empty state
      const cartResponse = await fetchWithRetry('/cart.js');
      const cart = await cartResponse.json();
      const isEmpty = !cart.items || cart.items.length === 0;

      if (isEmpty) {
        cartDrawer.classList.add('is-empty');
        if (targetQty) targetQty.classList.add('is-empty');
      } else {
        cartDrawer.classList.remove('is-empty');
        if (targetQty) targetQty.classList.remove('is-empty');
        
        // Remove empty content if it exists
        const emptyContent = cartDrawer.querySelector('.drawer__inner-empty');
        if (emptyContent) {
          emptyContent.remove();
        }
      }

      // Ensure the drawer is visible
      cartDrawer.style.display = '';
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      // Dispatch cart update event
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

    } catch (error) {
      console.error('Error reloading cart drawer:', error);
    }
  }

  // Add a retry mechanism for network operations
  async function fetchWithRetry(url, options, maxRetries = 3) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Request failed with status ${response.status}: ${errorText}`);
        }
        return response;
      } catch (error) {
        retries++;
        if (retries >= maxRetries) throw error;
        // Exponential backoff
        await new Promise(resolve => setTimeout(resolve, 200 * Math.pow(2, retries)));
      }
    }
  }

  async function checkAndUpdateCart(event) {
    if (isProcessing) {
      return;
    }
    
    try {
      isProcessing = true;

      // Add a small delay to ensure cart state is updated
      await new Promise(resolve => setTimeout(resolve, 100));

      const cartResponse = await fetchWithRetry('/cart.js');
      const cart = await cartResponse.json();

      // Check if cart is actually empty
      if (!cart.items || cart.items.length === 0) {
        isProcessing = false;
        return;
      }

      // Check for target products
      const hasTargetProducts = cart.items.some(item => 
        item.product_id.toString() === PRODUCT_ID && !item.properties?._free_item
      );
      
      if (!hasTargetProducts) {
        // Clean up any orphaned free items
        await cleanupOrphanedFreeItems(cart, hasTargetProducts);
      }

      // Process promotions
      await processPromotion(cart);

    } catch (error) {
      console.error('Error in cart update process:', error);
      try {
        await reloadCartDrawer();
      } catch (reloadError) {
        console.error('Failed to reload cart after error:', reloadError);
      }
    } finally {
      isProcessing = false;
    }
  }

  // Process the promotions for target product
  async function processPromotion(cart) {
    // Find target product items
    const targetItems = cart.items.filter(item => 
      item.product_id.toString() === PRODUCT_ID
    );

    if (targetItems.length === 0) {
      return;
    }

    // Separate paid and free items
    const paidItems = targetItems.filter(item => !item.properties?._free_item);
    const additionalFreeItems6Plus = cart.items.filter(item => 
      item.properties?._free_item && 
      item.variant_id.toString() === BONUS_VARIANT_ID &&
      (item.properties?._discount_type === '6+1 Free' || item.properties?._discount_type === '6+2 Free')
    );
    
    const additionalFreeItems4Plus = cart.items.filter(item => 
      item.properties?._free_item && 
      item.variant_id.toString() === BONUS_VARIANT_ID_2 &&
      item.properties?._discount_type === '4+2 Free'
    );

    const paidQuantity = paidItems.reduce((sum, item) => sum + item.quantity, 0);
    
    // First calculate how many multiples of 6
    const multiples6 = Math.floor(paidQuantity / 6); // How many multiples of 6
    
    // Then calculate remaining items after the 6+ promotion
    const remainingItems = paidQuantity - (multiples6 * 6);
    
    // Then calculate how many multiples of 4 from the remaining items
    const multiples4 = Math.floor(remainingItems / 4); // How many multiples of 4 from remaining items
    
    // Determine which promotions apply and how many times
    const shouldApply6PlusPromo = multiples6 > 0;
    const shouldApply4PlusPromo = multiples4 > 0;
    
    // Calculate the correct quantity of bonus items
    const bonus6Quantity = multiples6 * 1; // 1 bonus item per 6 items
    const bonus4Quantity = multiples4 * 2; // 2 bonus items per 4 items
    
    console.log(`Cart quantity: ${paidQuantity}, Multiples of 6: ${multiples6}, Remaining: ${remainingItems}, Multiples of 4: ${multiples4}`);
    console.log(`Bonus 6+: ${bonus6Quantity}, Bonus 4+: ${bonus4Quantity}`);
    
    let cartUpdated = false;
    
    // Process the 6+ promotion (1 bonus item per 6 items)
    if (shouldApply6PlusPromo) {
      const promoType = '6+1 Free';
      const bonusVariantId = BONUS_VARIANT_ID;
      
      // Check if the correct bonus items are already in the cart
      const hasCorrectBonus = additionalFreeItems6Plus.length > 0;
      const currentQuantity = additionalFreeItems6Plus.reduce((sum, item) => sum + item.quantity, 0);
      const correctQuantity = currentQuantity === bonus6Quantity;
      
      // Also consider it incorrect if it has the old promo type
      const hasOldPromoType = additionalFreeItems6Plus.some(item => item.properties?._discount_type === '6+2 Free');
      
      const needsUpdate = !hasCorrectBonus || !correctQuantity || hasOldPromoType;
      
      if (needsUpdate) {
        // Remove existing 6+ bonus items
        for (const freeItem of additionalFreeItems6Plus) {
          try {
            const removeResponse = await fetchWithRetry('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: freeItem.key,
                quantity: 0
              })
            });
            
            if (!removeResponse.ok) {
              const errorText = await removeResponse.text();
              console.error(`Error removing 6+ bonus item: ${errorText}`);
              throw new Error(`Failed to remove 6+ bonus item: ${errorText}`);
            }
            
            cartUpdated = true;
          } catch (error) {
            console.error('Error removing 6+ bonus item:', error);
          }
        }
        
        // Wait for removals to complete
        if (cartUpdated) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        // Add the 6+ bonus items
        if (bonus6Quantity > 0) {
          try {
            const itemsToAdd = [{
              id: bonusVariantId,
              quantity: bonus6Quantity,
              properties: {
                _free_item: true,
                _discount_type: promoType
              }
            }];
            
            const addResponse = await fetchWithRetry('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: itemsToAdd })
            });
            
            if (!addResponse.ok) {
              const errorText = await addResponse.text();
              throw new Error(`Failed to add 6+ free items: ${errorText}`);
            }
            
            cartUpdated = true;
          } catch (error) {
            console.error('Error adding 6+ free items:', error);
          }
        }
      }
    } else {
      // Remove any 6+ bonus items if the user doesn't qualify anymore
      if (additionalFreeItems6Plus.length > 0) {
        for (const freeItem of additionalFreeItems6Plus) {
          try {
            const removeResponse = await fetchWithRetry('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: freeItem.key,
                quantity: 0
              })
            });
            
            if (!removeResponse.ok) {
              const errorText = await removeResponse.text();
              console.error(`Error removing 6+ bonus item: ${errorText}`);
              throw new Error(`Failed to remove 6+ bonus item: ${errorText}`);
            }
            
            cartUpdated = true;
          } catch (error) {
            console.error('Error removing 6+ bonus item:', error);
          }
        }
        
        // Wait for removals to complete
        if (cartUpdated) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
    }
    
    // Process the 4+ promotion (2 bonus items per 4 items)
    if (shouldApply4PlusPromo) {
      const promoType = '4+2 Free';
      const bonusVariantId = BONUS_VARIANT_ID_2;
      
      // Check if the correct bonus items are already in the cart
      const hasCorrectBonus = additionalFreeItems4Plus.length > 0;
      const currentQuantity = additionalFreeItems4Plus.reduce((sum, item) => sum + item.quantity, 0);
      const correctQuantity = currentQuantity === bonus4Quantity;
      
      const needsUpdate = !hasCorrectBonus || !correctQuantity;
      
      if (needsUpdate) {
        // Remove existing 4+ bonus items
        for (const freeItem of additionalFreeItems4Plus) {
          try {
            const removeResponse = await fetchWithRetry('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: freeItem.key,
                quantity: 0
              })
            });
            
            if (!removeResponse.ok) {
              const errorText = await removeResponse.text();
              console.error(`Error removing 4+ bonus item: ${errorText}`);
              throw new Error(`Failed to remove 4+ bonus item: ${errorText}`);
            }
            
            cartUpdated = true;
          } catch (error) {
            console.error('Error removing 4+ bonus item:', error);
          }
        }
        
        // Wait for removals to complete
        if (cartUpdated) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        // Add the 4+ bonus items
        if (bonus4Quantity > 0) {
          try {
            const itemsToAdd = [{
              id: bonusVariantId,
              quantity: bonus4Quantity,
              properties: {
                _free_item: true,
                _discount_type: promoType
              }
            }];
            
            const addResponse = await fetchWithRetry('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: itemsToAdd })
            });
            
            if (!addResponse.ok) {
              const errorText = await addResponse.text();
              throw new Error(`Failed to add 4+ free items: ${errorText}`);
            }
            
            cartUpdated = true;
          } catch (error) {
            console.error('Error adding 4+ free items:', error);
          }
        }
      }
    } else {
      // Remove any 4+ bonus items if the user doesn't qualify anymore
      if (additionalFreeItems4Plus.length > 0) {
        for (const freeItem of additionalFreeItems4Plus) {
          try {
            const removeResponse = await fetchWithRetry('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: freeItem.key,
                quantity: 0
              })
            });
            
            if (!removeResponse.ok) {
              const errorText = await removeResponse.text();
              console.error(`Error removing 4+ bonus item: ${errorText}`);
              throw new Error(`Failed to remove 4+ bonus item: ${errorText}`);
            }
            
            cartUpdated = true;
          } catch (error) {
            console.error('Error removing 4+ bonus item:', error);
          }
        }
      }
    }

    // Force reload the cart drawer if we made changes
    if (cartUpdated) {
      await new Promise(resolve => setTimeout(resolve, 200));
      await reloadCartDrawer();
    }
  }

  // Helper function to handle empty cart state
  async function handleEmptyCartState() {
    try {
      // Get updated cart data to confirm it's empty
      const updatedCartResponse = await fetchWithRetry('/cart.js');
      const updatedCart = await updatedCartResponse.json();
      
      if (!updatedCart.items || updatedCart.items.length === 0) {
        // Force the cart drawer to show empty state
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-empty');
          
          // Get the cart drawer items element
          const cartItems = document.querySelector('cart-drawer-items');
          if (cartItems) {
            cartItems.classList.add('is-empty');
            cartItems.innerHTML = '';
          }
          
          // Fetch the empty cart template
          const emptyCartResponse = await fetchWithRetry(`${window.location.origin}?section_id=cart-drawer`);
          const emptyCartHtml = await emptyCartResponse.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(emptyCartHtml, 'text/html');
          
          // Get the empty drawer content
          const emptyDrawerContent = doc.querySelector('.drawer__inner-empty');
          if (emptyDrawerContent) {
            // Find or create the empty drawer container
            let currentEmptyDrawer = document.querySelector('.drawer__inner-empty');
            if (!currentEmptyDrawer) {
              currentEmptyDrawer = document.createElement('div');
              currentEmptyDrawer.classList.add('drawer__inner-empty');
              const drawerInner = document.querySelector('.drawer__inner');
              if (drawerInner) {
                drawerInner.appendChild(currentEmptyDrawer);
              }
            }
            
            // Update the empty drawer content
            currentEmptyDrawer.innerHTML = emptyDrawerContent.innerHTML;
          }
          
          // Force open the drawer
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
          
          // Dispatch standard Shopify events
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
      } else {
        // Cart is not empty, do normal reload
        await reloadCartDrawer();
      }
    } catch (error) {
      console.error('Error handling empty cart state:', error);
      // Try standard reload as fallback
      await reloadCartDrawer();
    }
  }

  // Improve the debounce function to better handle race conditions
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      // Cancel any pending executions
      clearTimeout(timeout);
      
      // Schedule new execution
      timeout = setTimeout(() => {
        // Only execute if not currently processing
        if (!isProcessing) {
          func(...args);
        }
      }, wait);
    };
  }

  // Modify the debounce time to be shorter
  const debouncedCheckAndUpdate = debounce(checkAndUpdateCart, 100);

  // Update event listeners
  const cartEvents = ['cart:change', 'cart:update', 'product:added', 'cart-drawer-items:updated'];
  cartEvents.forEach(event => 
    document.addEventListener(event, debouncedCheckAndUpdate)
  );

  // Listen for cart drawer close events
  document.addEventListener('cart:toggle', function(event) {
    setTimeout(() => checkAndUpdateCart(event), 200);
  });
  
  // Listen for drawer close event
  document.addEventListener('drawerClose', function(event) {
    setTimeout(() => checkAndUpdateCart(event), 200);
  });
  
  // Listen for click outside the cart drawer
  document.addEventListener('click', function(event) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !cartDrawer.hasAttribute('open')) return;
    
    // Check if click is outside the cart drawer
    if (!cartDrawer.contains(event.target) && !event.target.closest('cart-drawer')) {
      // Use the exact same approach as the close button
      // This is the key - directly call the close() method on the cart-drawer element
      cartDrawer.close();
      
      // Run cart check after a delay
      safeSetTimeout(() => checkAndUpdateCart(event), 200, 'outsideClickCheck');
    }
  });

  // Check when products are added via form
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form.matches('form[action="/cart/add"]')) {
      setTimeout(() => checkAndUpdateCart(event), 200);
    }
  });

  // Check when quantity is changed
  document.addEventListener('change', function(event) {
    if (event.target.matches('[name="updates[]"]')) {
      setTimeout(() => checkAndUpdateCart(event), 200);
    }
  });

  // Hook into CartRemoveButton
  document.addEventListener('click', function(event) {
    const removeButton = event.target.closest('cart-remove-button');
    if (removeButton) {
      // Wait for Shopify's cart update to complete before checking
      setTimeout(() => checkAndUpdateCart(event), 200);
    }
  });

  // Initial check only, removing the interval
  setTimeout(() => {
    checkAndUpdateCart();
  }, 200);
  
  // Create a MutationObserver to watch for cart drawer updates
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Only process if we're not already processing
          if (!isProcessing) {
            setTimeout(() => checkAndUpdateCart({ type: 'drawer-mutation' }), 200);
            break; // Only trigger once per batch of mutations
          }
        }
      }
    });
    
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  // Add a cleanup function that could be called if needed
  function cleanupEventListeners() {
    eventListeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    eventListeners.length = 0;
  }

  // Store timeout IDs for better management
  const timeouts = {};

  function safeSetTimeout(callback, delay, id) {
    // Clear any existing timeout with this ID
    if (timeouts[id]) {
      clearTimeout(timeouts[id]);
    }
    
    // Set new timeout and store its ID
    timeouts[id] = setTimeout(() => {
      callback();
      delete timeouts[id]; // Clean up reference
    }, delay);
    
    return timeouts[id];
  }

  // Example usage:
  safeSetTimeout(() => checkAndUpdateCart(event), 200, 'cartDrawerUpdate');

  // Update the cleanupOrphanedFreeItems function to handle the new promo type
  async function cleanupOrphanedFreeItems(cart, hasTargetProducts) {
    let cartUpdated = false;
    
    // Find all free items in the cart
    const freeItems = cart.items.filter(item => item.properties?._free_item);
    
    for (const freeItem of freeItems) {
      let shouldRemove = false;
      
      // Check for promotion free items
      if ((freeItem.properties?._discount_type === '4+2 Free' || 
           freeItem.properties?._discount_type === '6+1 Free' ||
           freeItem.properties?._discount_type === '6+2 Free') && 
          !hasTargetProducts) {
        shouldRemove = true;
      }
      
      if (shouldRemove) {
        try {
          const removeResponse = await fetchWithRetry('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: freeItem.key,
              quantity: 0
            })
          });
          
          if (!removeResponse.ok) {
            throw new Error(`Failed to remove orphaned free item: ${await removeResponse.text()}`);
          }
          
          cartUpdated = true;
        } catch (error) {
          console.error('Error removing orphaned item:', error);
          // Continue with other items even if one fails
        }
      }
    }
    
    // Get updated cart data after removing items
    if (cartUpdated) {
      try {
        // Wait a moment for Shopify to process the changes
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // Get the updated cart
        const updatedCartResponse = await fetchWithRetry('/cart.js');
        const updatedCart = await updatedCartResponse.json();
        
        // Check if cart is empty
        if (!updatedCart.items || updatedCart.items.length === 0) {
          await handleEmptyCartState();
        } else {
          await reloadCartDrawer();
        }
        
        return updatedCart;
      } catch (error) {
        console.error('Error updating cart after cleanup:', error);
        // Force a complete cart refresh
        await reloadCartDrawer();
      }
    }
    
    return cart;
  }
}); 